// eslint-disable-next-line no-restricted-imports
import './tag-transform';
import React from 'react';
import { Provider } from 'react-redux';

import '@zafire/foundations/design-tokens.css';
import '@zafire/foundations/font-faces.css';
import '@zafire/foundations/assets/css/typography.css';
import '@zafire/foundations/variables.css';
import App from 'App';
import 'assets/fonts/fonts.css';
import store from 'store';
import { createRoot } from 'react-dom/client';
import { ZfWebComponentsConfig, ZfIconProvider } from '@zafire/react';
import { getIconProviderUrl } from 'utils/browserUtil';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    {/* Needed even without props: applies the theme, mode and density classes the Zafire design tokens depend on. */}
    <ZfWebComponentsConfig>
      <ZfIconProvider baseUrl={getIconProviderUrl()}>
        <App />
      </ZfIconProvider>
    </ZfWebComponentsConfig>
  </Provider>,
);
